// src/api/client.ts
import axios, { AxiosHeaders } from "axios";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import localforage from "localforage";


const isDevLocal = import.meta.env.VITE_PWA_DEV_LOCAL === "true";

export const api = axios.create({
  baseURL: isDevLocal ? "/api" : import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");

  if (!config.headers) {
    config.headers = new AxiosHeaders();
  }

  if (token) {
    config.headers.Authorization = token.startsWith("Bearer ")
      ? token
      : `Bearer ${token}`;
  }

  const isFormData =
    typeof FormData !== "undefined" && config.data instanceof FormData;

  if (isFormData) {
    delete (config.headers as any)["Content-Type"];
    delete (config.headers as any)["content-type"];
  } else {
    if (
      !(config.headers as any)["Content-Type"] &&
      !(config.headers as any)["content-type"]
    ) {
      (config.headers as any)["Content-Type"] = "application/json";
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");
    const isMtsStatusRequest = requestUrl.endsWith("/auth/mts/status");

    if (status === 401 && !isMtsStatusRequest) {
      console.warn("⚠️ 401 → Авто-логаут");

      const authStore = useAuthStore();
      const userStore = useUserStore();

      authStore.clear();
      userStore.$reset();

      localStorage.removeItem("access_token");
      localStorage.removeItem("user");
      localStorage.removeItem("mainImage");
      localStorage.removeItem("conversations-store");
      localStorage.removeItem("subscription_store");
      sessionStorage.clear();

      await localforage.clear();

      router.push("/");

      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);
